import React, { useState, useRef } from 'react';

const ControldocAiChatInput = (props) => {
  const {
    onSend,
    disabled,
    messagesCount,
    configuration: {
      enabledFileButton
    },
  } = props;

  const [message, setMessage] = useState('');
  const [file, setFile] = useState(null);
  const fileInputRef = useRef(null);
  const textareaRef = useRef(null);

  const onSubmit = (e) => {
    e.preventDefault();

    if (message.trim() || file) {
      const formData = new FormData();
      formData.append('message', message);
      formData.append('messages_count', messagesCount);
      if (file) {
        formData.append('file', file);
      }

      const focusInput = () => {
        if (textareaRef.current) textareaRef.current.focus();
      };

      onSend(formData, focusInput);
      setMessage('');
      setFile(null);

      if (fileInputRef.current) fileInputRef.current.value = '';
    }
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      onSubmit(e);
    }
  };

  const onFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const onAttachFile = () => {
    fileInputRef.current.click();
  };

  const renderFileButton = () => {
    if (enabledFileButton) {
      return (
        <div className="d-flex justify-content-start">
          <button
            type="button"
            className="btn btn-sm btn-light mr-2"
            onClick={onAttachFile}
            disabled={disabled}
            title="Adjuntar archivo">
            <i className="fas fa-paperclip"></i>
          </button>
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: 'none' }}
            onChange={onFileChange}
            accept=".pdf,.doc,.docx,.xlsx,.xls,.csv"
          />
        </div>
      )
    }
  }

  return (
    <form onSubmit={onSubmit} className="chat-input-form">
      <div className="d-flex flex-column">
        <div className="flex-grow-1 mr-2 mb-2">
          <textarea
            ref={textareaRef}
            className="form-control"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Escribe tu consulta..."
            onKeyDown={onKeyDown}
            disabled={disabled}
          />
          {file && (
            <div className="mt-2 small text-muted w-100">
              <i className="fas fa-paperclip"></i> Archivo adjunto:&nbsp;
              <a
                href={URL.createObjectURL(file)}
                target="_blank"
                rel="noopener noreferrer"
              >
                {file.name}
              </a>
            </div>
          )}
        </div>
        <div className="row align-items-center">
          <div className="col-md-6">
            { renderFileButton() }
          </div>
          <div className="col-md-6 d-flex justify-content-end">
            <button
              className="btn btn-secondary btn-gradient btn-icon mt-3 m-sm-0"
              type="submit"
              disabled={disabled || !message.trim()}
            >
              <span className="content-btn fw-bold text-center">
                <i className="fas fa-paper-plane fa-lg"></i>
              </span>
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default ControldocAiChatInput;
